import React, { useState } from 'react';
import { db, auth } from './firebase'; // Importa a tua ligação oficial ao Firebase
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { moverSaldo } from './saldoUtilizador'; // Importa a tua função de controlo de carteira

export default function Levantamentos({ userDados, setEcraAtivo }) {
  // Estados para guardar o que o utilizador escreve no formulário
  const [metodo, setMetodo] = useState('banco');
  const [quantasBolas, setQuantasBolas] = useState('');
  const [titular, setTitular] = useState('');
  const [taxId, setTaxId] = useState('');
  const [iban, setIban] = useState('');
  const [swift, setSwift] = useState('');
  const [emailPaypal, setEmailPaypal] = useState('');
  const [processando, setProcessando] = useState(false); // Tranca anti-clique duplo profissional
  
  // Puxa o saldo REAL de Bolas usando o teu campo oficial da base de dados (saldoBolas)
  const saldoRealBolas = userDados?.saldoBolas || 0; 

    // Regra de Negócio Segura: Mínimo de 64.103 Bolas para atingir exatamente 50,00 Payout Points
  const MINIMO_BOLAS_LEVANTAMENTO = 64103;
  const TAXA_CONVERSAO_BOLA = 0.00078; // Rácio de segurança oficial (1000 BOLAS = 0,78 Payout Points)

  // Cálculo dos pontos brutos acumulados que o criador detém na conta
  const valorTotalPointsBruto = (saldoRealBolas * TAXA_CONVERSAO_BOLA).toFixed(2);

  // Definição das taxas administrativas por método (Banco: 2% | PayPal: 5%)
  const taxaPercentual = metodo === 'banco' ? 0.02 : 0.05;

  // Cálculo dos valores dinâmicos com base no que o utilizador digitou na caixa
  const quantidadeDigitada = parseInt(quantasBolas) || 0;
  const pointsBrutosDigitados = quantidadeDigitada * TAXA_CONVERSAO_BOLA;
  const taxaDeduzidaDigitada = pointsBrutosDigitados * taxaPercentual;

  // Valor líquido final em Pontos que será convertido na transferência bancária
  const valorLiquidoFinal = (pointsBrutosDigitados - taxaDeduzidaDigitada).toFixed(2);

  // Processar o Pedido de Levantamento Real e gravar no Firestore
  const lidarComPedido = async (e) => {
    e.preventDefault();

    if (processando) return; // Se já estiver a carregar, bloqueia o clique duplo

    const quantidadeAObter = parseInt(quantasBolas);
    const meuUid = auth.currentUser?.uid;

    if (!meuUid) {
      alert("Erro de autenticação. Por favor, volte a entrar na sua conta.");
      return;
    }

    // 1. TRANCAS DE SEGURANÇA MÁXIMA UNIVERSAL
    if (isNaN(quantidadeAObter) || quantidadeAObter < MINIMO_BOLAS_LEVANTAMENTO) {
      alert(`Segurança: O valor mínimo para resgate é de ${MINIMO_BOLAS_LEVANTAMENTO.toLocaleString()} Bolas (50,00€).`);
      return;
    }

    if (quantidadeAObter > saldoRealBolas) {
      alert("Margem insuficiente! Não tens Bolas suficientes na tua carteira.");
      return;
    }

    if (!titular || !taxId) {
      alert("Por favor, preenche o Nome do Titular e o NIF / Tax ID.");
      return;
    }

    if (metodo === 'banco' && (!iban || !swift)) {
      alert("O IBAN e o código SWIFT/BIC são obrigatórios para transferências bancárias.");
      return;
    }

    if (metodo === 'paypal' && !emailPaypal) {
      alert("Por favor, introduz o e-mail associado à tua conta PayPal.");
      return;
    }

    // 2. ARRANQUE DO PROCESSO DE GRAVAÇÃO REAL
    setProcessando(true);

    try {
      // 3. RETIRA AS BOLAS DA CARTEIRA DO UTILIZADOR NA HORA (Evita que ele peça o dobro em simultâneo)
      await moverSaldo(meuUid, { bolas: -quantidadeAObter });

      // 4. CRIA O DOCUMENTO DE ORDEM DE PAGAMENTO PARA O MIGUEL CONSULTAR NO FIREBASE
      await addDoc(collection(db, "pedidos_levantamento"), {
        userId: meuUid,
        userName: userDados?.userName || "Craque do Estádio",
        userEmail: auth.currentUser?.email || "",
        metodoPagamento: metodo,
        bolasResgatadas: quantidadeAObter,
              bolasResgatadas: quantidadeAobter,
      valorBrutoPoints: parseFloat(pointsBrutosDigitados.toFixed(2)),
      taxaPlataformaPoints: parseFloat(taxaDeduzidaDigitada.toFixed(2)),
      valorLiquidoAPagarPoints: parseFloat(valorLiquidoFinal),
        detalhesFaturacao: {
          titular: titular,
          nif: taxId,
          iban: metodo === 'banco' ? iban : null,
          swift: metodo === 'banco' ? swift : null,
          paypalEmail: metodo === 'paypal' ? emailPaypal : null
        },
        status: "PENDENTE", // Tu mudas para "PAGO" na consola quando fizeres a transferência bancária
        criadoEm: serverTimestamp()
      });

      alert(`🏟️ Sucesso! O teu pedido de levantamento de ${quantidadeAObter.toLocaleString()} BOLAS (${valorLiquidoFinal}€ Líquidos) foi enviado para análise. O valor foi deduzido do teu saldo.`);
      
      // Limpa os campos do formulário e recua para o feed/perfil
      setQuantasBolas('');
      setEcraAtivo('perfil');

    } catch (erroFirebase) {
      console.error("Erro fatal ao processar levantamento real:", erroFirebase);
      alert("Erro ao conectar com o banco de dados. O teu saldo não foi alterado.");
    } finally {
      setProcessando(false);
    }
  };

  return (
    <div style={{ padding: '20px', fontFamily: 'sans-serif', maxWidth: '450px', margin: '0 auto', color: '#fff', backgroundColor: '#000', minHeight: '100vh', overflowY: 'auto', boxSizing: 'border-box' }}>

    {/* Botão para Voltar ao Perfil */}
      <button 
        type="button" 
        onClick={() => setEcraAtivo('perfil')}
        style={{ background: 'none', border: 'none', color: '#00ff66', cursor: 'pointer', fontSize: '14px', marginBottom: '15px', display: 'flex', alignItems: 'center', gap: '5px', padding: 0 }}
      >
        ← Voltar ao Perfil
      </button>

            {/* CABEÇALHO DA CARTEIRA & CAIXA DE SALDO SEGURO */}
        <div style={{ textAlign: 'center', marginTop: '20px' }}>
          <h2 style={{ color: '#fff', fontSize: '22px', fontWeight: '900', textTransform: 'uppercase', letterSpacing: '1px', margin: 0 }}>
            A Minha Carteira <span style={{ fontSize: '20px' }}>⚽</span>
          </h2>
          <p style={{ fontSize: '11px', color: '#666', marginTop: '2px', textTransform: 'uppercase', letterSpacing: '1px' }}>
            GameFut Live Global Payouts
          </p>

          <div style={{ 
            background: '#111', 
            border: '1px solid #39FF14', 
            borderRadius: '14px', 
            padding: '20px', 
            margin: '20px auto', 
            maxWidth: '450px',
            boxShadow: '0 0 15px rgba(57, 255, 20, 0.15)'
          }}>
            <span style={{ color: '#aaa', fontSize: '12px', fontWeight: 'bold', textTransform: 'uppercase' }}>
              Saldo Real Disponível
            </span>
            <h1 style={{ color: '#fff', fontSize: '28px', fontWeight: '900', margin: '5px 0' }}>
              {saldoRealBolas.toLocaleString()} BOLAS
            </h1>
            <div style={{ color: '#39FF14', fontSize: '14px', fontWeight: 'bold' }}>
              ~ {valorTotalPointsBruto} Pontos de Resgate (Bruto)
          </div>
        </div>

          <p style={{ fontSize: '11px', color: '#888', maxWidth: '450px', margin: '0 auto 20px auto', lineHeight: '1.4' }}>
            ℹ️ Os pedidos de resgate podem ser solicitados a qualquer momento. Os valores validados são liquidados e transferidos de forma segura para o teu IBAN ou PayPal <strong>todas as terças-feiras</strong>.
          </p>
        </div>

      {/* Formulário Oficial */}
      <form onSubmit={lidarComPedido}>
        
        {/* Quantidade com Estimativa Líquida */}
        <div style={{ marginBottom: '10px' }}>
          <label style={{ display: 'block', marginBottom: '3px', color: '#00ff66', fontSize: '12px', textTransform: 'uppercase' }}>Quantidade de Bolas:</label>
          <input 
            type="number" 
            placeholder={`Mínimo ${MINIMO_BOLAS_LEVANTAMENTO.toLocaleString()} Bolas`}
            value={quantasBolas}
            onChange={(e) => setQuantasBolas(e.target.value)}
            style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #333', backgroundColor: '#111', color: '#fff', boxSizing: 'border-box', fontSize: '14px' }}
          />
          
          {/* Caixa de Recibo em Tempo Real */}
          {quantidadeDigitada >= MINIMO_BOLAS_LEVANTAMENTO && (
            <div style={{ background: '#111', padding: '8px', borderRadius: '6px', marginTop: '6px', border: '1px dashed #444', fontSize: '12px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', color: '#aaa' }}>
                <span>Valor Bruto:</span> <span style={{ marginLeft: 'auto' }}>{eurosBrutosDigitados.toFixed(2)} €</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', color: '#ff4444' }}>
                <span>Taxa de Processamento ({metodo === 'banco' ? '2%' : '5%'}):</span> <span style={{ marginLeft: 'auto' }}>- {taxaDeduzidaDigitada.toFixed(2)} €</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', color: '#00ff66', fontWeight: 'bold', marginTop: '4px', borderTop: '1px solid #222', paddingTop: '4px' }}>
                <span>Valor Líquido a Receber:</span> <span style={{ marginLeft: 'auto' }}>{valorLiquidoFinal} €</span>
              </div>
            </div>
          )}
        </div>

        {/* Métodos Atualizados */}
        <div style={{ marginBottom: '20px' }}>
          <div style={{ display: 'flex', gap: '10px' }}>
            <button 
              type="button"
              onClick={() => setMetodo('banco')}
              style={{ flex: 1, padding: '12px', borderRadius: '8px', border: metodo === 'banco' ? '2px solid #00ff66' : '1px solid #333', backgroundColor: '#111', color: '#fff', cursor: 'pointer', fontWeight: 'bold' }}
            >
              🏦 Banco (Wise / Revolut)
            </button>
            <button 
              type="button"
              onClick={() => setMetodo('paypal')}
              style={{ flex: 1, padding: '12px', borderRadius: '8px', border: metodo === 'paypal' ? '2px solid #00ff66' : '1px solid #333', backgroundColor: '#111', color: '#fff', cursor: 'pointer', fontWeight: 'bold' }}
            >
              💳 PayPal
            </button>
          </div>
        </div>

                {/* Nome do Titular */}
        <div style={{ marginBottom: '10px' }}>
          <label style={{ display: 'block', marginBottom: '3px', color: '#ccc', fontSize: '12px' }}>Nome do Titular:</label>
          <input 
            type="text" 
            placeholder="Nome igual ao banco"
            value={titular}
            onChange={(e) => setTitular(e.target.value)}
            style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #333', backgroundColor: '#111', color: '#fff', boxSizing: 'border-box', fontSize: '13px' }}
          />
        </div>

        {/* NIF / Tax ID */}
        <div style={{ marginBottom: '10px' }}>
          <label style={{ display: 'block', marginBottom: '3px', color: '#ccc', fontSize: '12px' }}>NIF / Tax ID Global:</label>
          <input 
            type="text" 
            placeholder="Identificação Fiscal"
            value={taxId}
            onChange={(e) => setTaxId(e.target.value)}
            style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #333', backgroundColor: '#111', color: '#fff', boxSizing: 'border-box', fontSize: '13px' }}
          />
        </div>

                {/* Banco Campos Lado a Lado para poupar espaço */}
        {metodo === 'banco' && (
          <div style={{ display: 'flex', gap: '10px', marginBottom: '10px' }}>
            <div style={{ flex: 2 }}>
              <label style={{ display: 'block', marginBottom: '3px', color: '#ccc', fontSize: '12px' }}>IBAN / Conta:</label>
              <input 
                type="text" 
                placeholder="Internacional"
                value={iban}
                onChange={(e) => setIban(e.target.value)}
                style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #333', backgroundColor: '#111', color: '#fff', boxSizing: 'border-box', fontSize: '13px' }}
              />
            </div>
            <div style={{ flex: 1 }}>
              <label style={{ display: 'block', marginBottom: '3px', color: '#ccc', fontSize: '12px' }}>SWIFT / BIC:</label>
              <input 
                type="text" 
                placeholder="Ex: NIBO..."
                value={swift}
                onChange={(e) => setSwift(e.target.value)}
                style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #333', backgroundColor: '#111', color: '#fff', boxSizing: 'border-box', fontSize: '13px' }}
              />
            </div>
          </div>
        )}

        {/* PayPal Campos */}
        {metodo === 'paypal' && (
          <div style={{ marginBottom: '25px' }}>
            <label style={{ display: 'block', marginBottom: '5px', color: '#ccc', fontSize: '13px' }}>E-mail PayPal Business:</label>
            <input 
              type="email" 
              placeholder="utilizador@email.com"
              value={emailPaypal}
              onChange={(e) => setEmailPaypal(e.target.value)}
              style={{ width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid #333', backgroundColor: '#111', color: '#fff', boxSizing: 'border-box' }}
            />
          </div>
        )}

        <button 
          type="submit" 
          style={{ width: '100%', padding: '14px', borderRadius: '8px', border: 'none', backgroundColor: '#00ff66', color: '#000', fontWeight: 'bold', fontSize: '15px', cursor: 'pointer', textTransform: 'uppercase' }}
        >
          Solicitar Resgate
        </button>

      </form>
    </div>
  );
}
